import { Form } from "antd";
import { useDiscountsListing } from "../../context/DiscountsListingContext";
import { INITIAL_DISCOUNT_SEARCH } from "../../constants";
import { useDebounceFn } from "src/hooks/useDebounce";
import CategoriesField from "./components/CategoriesField/CategoriesField";

export default function Filters() {
  const { setFilters } = useDiscountsListing();
  const debouncedSetFilters = useDebounceFn(setFilters, 300);

  return (
    <Form initialValues={INITIAL_DISCOUNT_SEARCH} className="w-full" onValuesChange={debouncedSetFilters}>
      <Form.Item name="categoryCode" className="m-0! w-full!">
        <CategoriesField />
      </Form.Item>
    </Form>
  );
}
